// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderStatusInformationStyles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusInformation";
import xOrderInformationStyles from "@rpsc/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { color, mergeWithCss, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

orderStatusInformationStyles.informationWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        flex-wrap: wrap;
        padding-bottom: 20px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};
orderStatusInformationStyles.wrapper = {
    ...mergeWithCss(xOrderInformationStyles.headingAndTextStyles?.wrapper, {
        css: css`
            width: 50%;
            align-items: center;
            ${xScreen("lte", "md")} {
                width: 50%;
            }
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
    }),
};
orderStatusInformationStyles.titleText = {
    ...xOrderInformationStyles.labelWithDots,
};
orderStatusInformationStyles.orderNumberText =
    orderStatusInformationStyles.orderNumberText =
    orderStatusInformationStyles.orderDateText =
    orderStatusInformationStyles.poNumberText =
    orderStatusInformationStyles.termsText =
    orderStatusInformationStyles.statusText =
        {
            ...xOrderInformationStyles.value,
        };
